import "./index.scss"
import Header from "./components/Header"
import AboutUs from "./components/AboutUs"
import Qualification from "./components/Qualification"
import Partner from "./components/Partner"
import Evaluate from "./components/Evaluate"
import Recruit from "./components/Recruit"
import Footer from "../../components/Footer"
import Feedback from "../../components/Feedback"
import { useState } from "react";
import BackTop from "@/assets/back-top.png";
import contactus from "@/assets/contact_us.png";
function About() {
  // 返回顶部按钮
  function backToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  const [navBgc, setNavBgc] = useState("transparent")
  const [shadow, setShadow] = useState("")
  window.addEventListener("scroll", function () {
    if (document.documentElement.scrollTop >= 750) {
      setNavBgc("#fff")
      setShadow("0px 5px 12.8px 0px rgba(0, 0, 0, 0.08)")
    } else {
      setNavBgc("transparent")
      setShadow("")
    }
    var button = document.getElementById("scrollToTopButton");
    if (button) {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 100) {
        button.style.display = "block";
      } else {
        button.style.display = "none";
      }
    }
  });
  // 联系我们浮窗
  const [isHide, setIshide] = useState(true);
  const [position, setPosition] = useState({ top: "-90px", left: "-245px" });
  function contactusEnter() {
    setIshide(false);
  }
  function contactusLeave() {
    setIshide(true);
  }
  return (
    <div>
      <Header navBgc={navBgc} shadow={shadow}></Header>
      <AboutUs></AboutUs>
      <Qualification></Qualification>
      <Partner></Partner>
      <Evaluate></Evaluate>
      <Recruit></Recruit>
      <Footer></Footer>
      {/* 返回顶部按钮 */}
      <div id="scrollToTopButton" className="back-to-top" onClick={backToTop}>
        <img src={BackTop} className="img" />
      </div>
      {/* 联系我们浮窗 */}
      <div
        id="contactusDom"
        className="contact-us"
        onMouseEnter={contactusEnter}
        onMouseLeave={contactusLeave}
      >
        <img src={contactus} className="img"></img>
        {/* 返回表二维码 */}
        <Feedback
          isHide={isHide}
          position={position}
          tip="扫码联系再查查客服"
        />
      </div>
    </div>
  )
}
export default About